import { AttachmentOptions, uploadState } from "@/constants/attachment";
import { Attachments } from "@/screens/common/Attachments";
import { getAttachmentDescription } from "@/utils/attachments";
import { ReactNode, useContext } from "react";
import { EnumerationsContext } from "@/contexts/EnumerationsContext";
import { Dispatch, SetStateAction } from "react";
import styles from "./index.module.css";
import { ContractState } from "@/types/contract";

interface FileInputProps extends AttachmentOptions {
  value?: uploadState;
  error?: string;
  fileTypeCode: string;
  tooltipVisible?: boolean;
  helperText?: ReactNode;
  contractState: ContractState;
  setTooltipVisible?: Dispatch<SetStateAction<boolean>>;
  onChange?: (value: uploadState) => void;
  onUpload?: () => void;
}

export const FileInput = ({
  value,
  error,
  fileTypeCode,
  tooltipVisible,
  helperText,
  contractState,
  setTooltipVisible,
  onChange,
  onUpload,
  ...attachmentOptions
}: FileInputProps) => {
  const { attachments } = useContext(EnumerationsContext);

  return (
    <div className={styles.root}>
      <Attachments
        onSetUploaded={nextValue => {
          if (value !== nextValue) {
            onChange?.(nextValue);

            if (nextValue === "uploaded") {
              onUpload?.();
            }
          }
        }}
        contractState={contractState}
        helperText={helperText ?? getAttachmentDescription(attachments, fileTypeCode, contractState.contract.process)}
        fileTypeCode={fileTypeCode}
        tooltipVisible={tooltipVisible}
        setTooltipVisible={setTooltipVisible}
        validationError={error}
        {...attachmentOptions}
      />
    </div>
  );
};
